import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../assets/styles/attendeeDisplay.css'
import user_icon from '../assets/images/user_icon.png'
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useAuth } from './Auth/AuthContext';
import { API_BASE_URL } from '../config/api';

const AttendeeDisplay = () => {
    const location = useLocation();
    const { month, day, year } = useParams();
    const navigate = useNavigate();
    // const { numMonth, numDay, numYear } = location.state || {};
    const [attendeeData, setAttendeeData] = useState([])
    const [validResult, setValidResult] = useState(true);
    const [customEntries, setCustomEntries] = useState([]);
    const [entryName, setEntryName] = useState('');
    const [entryCount, setEntryCount] = useState('');
    const [congregationTotals, setCongregationTotals] = useState({});
    const monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const { token } = useAuth();

    useEffect(() => {
        const fetchSessions = async () => {
            if (!token || month === undefined || day === undefined || year === undefined) {
              return;
            }

            if(month !== undefined && day !== undefined && year !== undefined) {
                if(monthArr.indexOf(month) < 0) {
                    throw new Error("Invalid month provided")
                }
                try {
                    const response = await fetch(`${API_BASE_URL}/attendance/sessions/date/${year}-${monthArr.indexOf(month) + 1}-${day}`, {
                      'headers': {
                        'Authorization': `Bearer ${token}`
                      }
                    });
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    const data = await response.json();
                    setAttendeeData(data)
                    setValidResult(true);
                    console.log(data)

                    const totals = data.reduce((acc, user) => {
                      const group = user.Congregation || 'Other';
                      acc[group] = (acc[group] || 0) + 1;
                      return acc;
                    }, {});
                    setCongregationTotals(totals);

                    const entriesResponse = await fetch(
                      `${API_BASE_URL}/attendance/sessions/date/${year}-${monthArr.indexOf(month) + 1}-${day}/entries`,
                      { headers: { 'Authorization': `Bearer ${token}` } }
                    );
                    if (entriesResponse.ok) {
                        const entriesData = await entriesResponse.json();
                        console.log("Entries response data:", entriesData);
                        setCustomEntries(entriesData);
                    }

                } catch (error) {
                  setValidResult(false);
                } 
            }
            // else if(numMonth !== undefined && numDay !== undefined && numYear !== undefined) {
            //     try {
            //         const response = await fetch(`http://localhost:3002/attendance/sessions/date/${numYear}-${numMonth}-${numDay}`);
            //         if (!response.ok) {
            //             throw new Error('Network response was not ok');
            //         }
            //         const data = await response.json();
            //         setAttendeeData(data)
            //         console.log(data)
            //     } catch (error) {
            //     } finally {
            //     }
            // }
          };
          fetchSessions();
          generateAnalytics();
    }, [token, year, month, day]);

    const generateAnalytics = async () => {
        // const data = {
        //     month,
        //     year,
        //     // dashboardUid: 'adoe401m2y3ggf', // Your actual dashboard UID
        //     // panelId: 1 // Your actual panel ID
        //   };
        const adjustedMonth = monthArr.indexOf(month) + 1;
        console.log(adjustedMonth);

          const data = {
            adjustedMonth,
            day,
            year
          };          
      
          try {
            const response = await fetch(`${API_BASE_URL}/attendance/update-dashboard-date`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify(data)
            });
      
            if (!response.ok) {
              throw new Error(`Error updating dashboard: ${response.statusText}`);
            }
      
            const responseData = await response.json();
            console.log('Dashboard updated successfully:', responseData);
          } catch (error) {
            console.error('Error updating dashboard:', error);
          }
    }

    const addEntry = async () => {
      if (!entryName.trim() || !entryCount) return;
      try {
          const response = await fetch(
              `${API_BASE_URL}/attendance/sessions/date/${year}-${monthArr.indexOf(month) + 1}-${day}/entries`,
              {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`
                  },
                  body: JSON.stringify({ name: entryName.trim(), count: parseInt(entryCount) })
              }
          );
          const data = await response.json();
          setCustomEntries(prev => [...prev, { id: data.entry.id, name: data.entry.name, count: data.entry.count }]);
          setEntryName('');
          setEntryCount('');
      } catch(err) {
          console.error('Error adding entry:', err);
      }
    };

    const removeEntry = async (id, index) => {
        try {
            await fetch(
                `${API_BASE_URL}/attendance/sessions/entries/${id}`,
                {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${token}` }
                }
            );
            setCustomEntries(prev => prev.filter((_, i) => i !== index));
        } catch(err) {
            console.error('Error removing entry:', err);
        }
    };

    const downloadExcel = async () => {
      if (attendeeData.length === 0) return;

      const workbook = new ExcelJS.Workbook();
      const ws = workbook.addWorksheet('Session Report');

      // ── styles ─────────────────────────────────────────────────
      const darkHeader = {
        font: { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A3A5C' } },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const columnHeader = {
        font: { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF185FA5' } },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const totalRow = {
        font: { bold: true, size: 10 },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6F1FB' } },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const grandTotalRow = {
        font: { bold: true, size: 11 },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF185FA5' } },
        font2: { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const sectionLabel = {
        font: { bold: true, color: { argb: 'FF185FA5' }, size: 10 },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF0F5FB' } },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const alternateRow = {
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F7FA' } },
        font: { size: 10 },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const plainRow = {
        font: { size: 10 },
        alignment: { horizontal: 'left', vertical: 'middle' },
      };

      const applyStyle = (cell, style) => {
        if (style.font) cell.font = style.font;
        if (style.fill) cell.fill = style.fill;
        if (style.alignment) cell.alignment = style.alignment;
        if (style.border) cell.border = style.border;
      };

      const hairline = {
        top:    { style: 'thin', color: { argb: 'FFD0DCE8' } },
        bottom: { style: 'thin', color: { argb: 'FFD0DCE8' } },
        left:   { style: 'thin', color: { argb: 'FFD0DCE8' } },
        right:  { style: 'thin', color: { argb: 'FFD0DCE8' } },
      };

      const addStyledRow = (values, style, height = 18) => {
        const row = ws.addRow(values);
        row.height = height;
        values.forEach((_, i) => {
          const cell = row.getCell(i + 1);
          applyStyle(cell, style);
          cell.border = hairline;
        });
        return row;
      };

      const addBlankRow = () => {
        const row = ws.addRow([]);
        row.height = 8;
        return row;
      };

      // ── column widths ──────────────────────────────────────────
      ws.columns = [
        { width: 30 }, // Name / Label
        { width: 22 }, // Congregation / Value
        { width: 18 }, // Type / Count
        { width: 14 }, // Count
      ];

      // ── section 1: session info header ────────────────────────
      const titleRow = ws.addRow([`UUMC Attendance — Session Report`]);
      ws.mergeCells(ws.rowCount, 1, ws.rowCount, 4);
      applyStyle(titleRow.getCell(1), darkHeader);
      titleRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 13 };
      titleRow.height = 28;

      const dateRow = ws.addRow([`Date: ${month}/${day}/${year}`]);
      ws.mergeCells(ws.rowCount, 1, ws.rowCount, 4);
      applyStyle(dateRow.getCell(1), {
        font: { size: 10, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1A3A5C' } },
        alignment: { horizontal: 'left', vertical: 'middle' },
      });
      dateRow.height = 18;

      addBlankRow();

      // ── section 2: summary numbers ─────────────────────────────
      const secRow1 = ws.addRow(['SUMMARY']);
      ws.mergeCells(ws.rowCount, 1, ws.rowCount, 4);
      applyStyle(secRow1.getCell(1), sectionLabel);
      secRow1.height = 18;

      addStyledRow(['Metric', 'Count', '', ''], columnHeader, 18);

      // in-person total
      addStyledRow(['In-person attendees', attendeeData.length, '', ''], plainRow);

      // per congregation
      const congregationTotalsMap = attendeeData.reduce((acc, user) => {
        const cong = user.Congregation || 'Unknown';
        acc[cong] = (acc[cong] || 0) + 1;
        return acc;
      }, {});

      Object.entries(congregationTotalsMap).forEach(([cong, count], i) => {
        const style = i % 2 === 0 ? alternateRow : plainRow;
        const row = addStyledRow([`  · ${cong}`, count, '', ''], style);
        row.getCell(1).font = { size: 10, italic: true, color: { argb: 'FF4A6A8A' } };
      });

      // additional entries
      if (customEntries.length > 0) {
        addStyledRow(['Additional entries', additionalTotal, '', ''], plainRow);
        customEntries.forEach((entry, i) => {
          const style = i % 2 === 0 ? alternateRow : plainRow;
          const row = addStyledRow([`  · ${entry.name}`, entry.count, '', ''], style);
          row.getCell(1).font = { size: 10, italic: true, color: { argb: 'FF4A6A8A' } };
        });
      }

      // grand total
      const grandTotalRowObj = ws.addRow(['Grand total', grandTotal, '', '']);
      grandTotalRowObj.height = 20;
      ['FF185FA5', 'FF185FA5', 'FF185FA5', 'FF185FA5'].forEach((_, i) => {
        const cell = grandTotalRowObj.getCell(i + 1);
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF185FA5' } };
        cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
        cell.border = hairline;
      });
      grandTotalRowObj.getCell(1).value = 'Grand total';
      grandTotalRowObj.getCell(2).value = grandTotal;

      addBlankRow();

      // ── section 3: attendee list ───────────────────────────────
      const secRow2 = ws.addRow(['ATTENDEES']);
      ws.mergeCells(ws.rowCount, 1, ws.rowCount, 4);
      applyStyle(secRow2.getCell(1), sectionLabel);
      secRow2.height = 18;

      addStyledRow(['Name', 'Congregation', 'Type', ''], columnHeader, 18);

      attendeeData.forEach((user, i) => {
        const style = i % 2 === 0 ? alternateRow : plainRow;
        addStyledRow([user.Name, user.Congregation || '—', 'In-person', ''], style);
      });

      // additional entries inline
      if (customEntries.length > 0) {
        addBlankRow();

        const secRow3 = ws.addRow(['ADDITIONAL ENTRIES']);
        ws.mergeCells(ws.rowCount, 1, ws.rowCount, 4);
        applyStyle(secRow3.getCell(1), sectionLabel);
        secRow3.height = 18;

        addStyledRow(['Entry name', 'Count', 'Type', ''], columnHeader, 18);

        customEntries.forEach((entry, i) => {
          const style = i % 2 === 0 ? alternateRow : plainRow;
          addStyledRow([entry.name, entry.count, 'Additional', ''], style);
        });
      }

      // ── export ─────────────────────────────────────────────────
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `UUMC_${year}-${month}-${day}.xlsx`);
    };

    const additionalTotal = customEntries.reduce((sum, e) => sum + e.count, 0);
    const grandTotal = attendeeData.length + additionalTotal;
    const congregationCount = Object.keys(congregationTotals).length;

    return (
      <div className='container'>
        <div className={!validResult ? 'visible' : 'hidden'}>
          <div>No results found for {month}/{day}/{year}. Please try another search</div>
          <button className='return-home' onClick={() => navigate('/')}>Back to Home</button>
        </div>

        <div className={validResult ? 'visible' : 'hidden'}>
          <div className="uumc-session-label">Session — {month} {day}, {year}</div>

          {/* 4 metric cards */}
          <div className="uumc-stat-grid">
            <div className="uumc-stat-card">
              <div className="uumc-stat-label">In-person</div>
              <div className="uumc-stat-value">{attendeeData.length}</div>
            </div>
            <div className="uumc-stat-card">
              <div className="uumc-stat-label">Additional entries</div>
              <div className="uumc-stat-value">{additionalTotal}</div>
            </div>
            <div className="uumc-stat-card">
              <div className="uumc-stat-label">Grand total</div>
              <div className="uumc-stat-value">{grandTotal}</div>
            </div>
            <div className="uumc-stat-card">
              <div className="uumc-stat-label">Congregations</div>
              <div className="uumc-stat-value">{congregationCount}</div>
            </div>
          </div>

          {/* congregation breakdown + custom entries */}
          <div className="uumc-table-card">
            <div className="uumc-table-header">Attendance totals</div>
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>Group</th>
                  <th style={{textAlign: 'right'}}>Count</th>
                  <th style={{width: '40px'}}></th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(congregationTotals).map(([group, count]) => (
                  <tr key={group}>
                    <td>{group}</td>
                    <td style={{textAlign: 'right'}}>{count}</td>
                    <td></td>
                  </tr>
                ))}
                <tr className="uumc-total-row">
                  <td>In-person total</td>
                  <td style={{textAlign: 'right'}}>{attendeeData.length}</td>
                  <td></td>
                </tr>
                {customEntries.map((entry, i) => (
                  <tr key={entry.id} className="uumc-entry-row">
                    <td>{entry.name}</td>
                    <td style={{textAlign: 'right'}}>{entry.count}</td>
                    <td style={{textAlign: 'right'}}>
                      <button className="uumc-remove-btn" onClick={() => removeEntry(entry.id, i)}>×</button>
                    </td>
                  </tr>
                ))}
                <tr className="uumc-grand-row">
                  <td>Grand total</td>
                  <td style={{textAlign: 'right'}}>{grandTotal}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            {/* add entry section */}
            <div className="uumc-add-section">
              <div className="uumc-add-row">
                <input
                  className="uumc-add-name"
                  type="text"
                  placeholder="Entry name (e.g. Livestream, Special guests...)"
                  value={entryName}
                  onChange={(e) => setEntryName(e.target.value)}
                />
                <input
                  className="uumc-add-count"
                  type="number"
                  placeholder="Count"
                  min="0"
                  value={entryCount}
                  onChange={(e) => setEntryCount(e.target.value)}
                />
                <button className="uumc-add-btn" onClick={addEntry}>+ Add entry</button>
              </div>
              <div className="uumc-add-hint">Added entries roll into the grand total and are included in the downloaded spreadsheet.</div>
            </div>
          </div>

          {/* individual attendees — data-testid preserved */}
          <div className="uumc-table-card" data-testid="attendance-table-card">
            <div className="uumc-table-header">Individual attendees</div>
            <table className="attendance-table" data-testid="attendance-table">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Congregation</th>
                </tr>
              </thead>
              <tbody>
                {attendeeData.map((user, index) => (
                  <tr key={index} data-testid="attendance-row" onClick={() => navigate('/filter-by-user', { state: {name: user.Name} })}>
                    <td>
                      <div className='user-container'>
                        <img className='user_icon' src={user_icon}/>
                        <div data-testid="attendance-user-name">{user.Name}</div>
                      </div>
                    </td>
                    <td data-testid="attendance-user-congregation">{user.Congregation}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className='uumc-download-row'>
              <button className='uumc-download-btn' onClick={()=> {downloadExcel()}} data-testid="download-attendance-csv">
                Download CSV
              </button>
            </div>
          </div>

        </div>
      </div>
    )
}

export default AttendeeDisplay